import React from "react";
import "./squirrel.css";

// Squirrel loader should randomize display between the animations on each render
export function Squirrel() {
  const randomNum = React.useMemo(() => {
    return Math.floor(Math.random() * 3 + 1);
  }, []);
  const squirrelAsset = React.useMemo(() => {
    switch (randomNum) {
      case 1:
        return "/assets/images/squirrel.gif";
      case 2:
        return "/assets/images/squirrel2.gif";
      case 3:
        return "/assets/images/squirrel3.gif";
      default:
        return "/assets/images/squirrel.gif"; // Fallback to the first squirrel
    }
  }, [randomNum]);

  return (
    <div className="squirrel-loader">
      <div className="squirrel-wrapper">
        <img className="rounded-[8%]" src={squirrelAsset} />
      </div>
    </div>
  );
}
